import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import AddIcon from '@material-ui/icons/AddCircle';
import ImageIcon from '@material-ui/icons/Image';

import Avatar from '@material-ui/core/Avatar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuList from '@material-ui/core/MenuList';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MoreVertIcon from '@material-ui/icons/MoreVert';





export default class FileUpload extends React.Component {

    state = {
        upl_descricao: '',
        srcFile: '',
        isVisualizacao: false,
        isEdicao: false,
        indice: -1,
        arquivoBytes: null,
        itemSelected: null,
        id: 'form_files_' + Date.now()
    };

    handleClick = (item, indice, event) => {
        this.setState({ anchorEl: event.currentTarget, itemSelected: item, indice: indice });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, indice: -1, itemSelected: null });
    };

    onEditar = (isEdicao) => {
        var bytes = this.state.itemSelected.UplArquivo;
        var arquivoBinario = new Blob([new Uint8Array(bytes).buffer], { type: "image/png" });
        var url = window.URL.createObjectURL(arquivoBinario);

        this.setState({
            anchorEl: null,
            isEdicao: isEdicao,
            isVisualizacao: !isEdicao,
            upl_descricao: this.state.itemSelected.UplDescricao,
            arquivoBytes: bytes,

            srcFile: url
        }, () => {
            setTimeout(() => {
                document.querySelector('#' + this.state.id).scrollIntoView({ behaviour: "smooth" });
            }, 150);
        });
    };

    onCancelar = () => {
        this.setState({
            exibeDoc: false,
            indice: -1,
            isEdicao: false,
            erro: "",
            podeAlterar: true,
            upl_descricao: '',
            arquivoBytes: null
        });
    };

    onDelete = () => {
        this.props.onDeleteFile(this.state.indice);
        this.handleClose();
    };

    onChange(id, value) {
        if (this.state.isVisualizacao) {
            return;
        }
        this.setState({
            [id]: value
        });
    }


    resizeImg(img) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const width = 800;
        const scaleFactor = width / img.width;
        canvas.width = width;
        canvas.height = img.height * scaleFactor;
        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
        ctx.canvas.toBlob((blob) => {
            var url = window.URL.createObjectURL(blob);
            var fileReader = new FileReader();
            fileReader.onload = (event) => {
                var arrayBuffer = event.target.result;
                var typedArray = new Uint8Array(arrayBuffer);
                typedArray = Array.prototype.slice.call(typedArray);//precisa ser do tipo array 
                this.setState({
                    arquivoBytes: typedArray,
                    srcFile: url
                });
            };
            fileReader.readAsArrayBuffer(blob);
        }, 'image/png', 1);
    }

    onChangeFile(files) {
        if (!files || this.state.isVisualizacao) {
            return;
        }
        let file = files[0];
        let type = file.type;
        if (type.indexOf('image') === -1) {
            alert('Selecione apenas arquivos de imagem.');
            return;
        }
        let fr = new FileReader();
        fr.onerror = () => {
            alert('Erro ao ler arquivo');
        };
        fr.onloadend = (e) => {
            // let arquivoArrayBuffer = e.target.result;
            // var arquivoBinario = new Blob([arquivoArrayBuffer], { type: type });
            // var url = window.URL.createObjectURL(arquivoBinario);
            // var typedArray = new Uint8Array(arquivoArrayBuffer);
            // typedArray = Array.prototype.slice.call(typedArray);

            // this.setState({
            //     arquivoBytes: typedArray,
            //     srcFile: url
            // });
            var img = new Image();
            img.onload = () => {
                this.resizeImg(img);
            };
            img.src = e.target.result;
        };
        fr.readAsDataURL(file);
    }

    limpar() {
        this.setState({
            upl_descricao: '',
            arquivoBytes: null,
            isVisualizacao: false,
            srcFile: '',
            isEdicao: false,
            indice: -1,
            itemSelected: null
        });
    }

    toogleDoc() {
        this.setState({
            exibeDoc: !this.state.exibeDoc
        });
    }

    save() {
        if (!this.state.upl_descricao || !this.state.arquivoBytes) {
            alert('Informe Descrição e um arquivo de imagem');
            console.error('no descr e file');
            return;
        }
        this.props.onSaveFile(this.props.origem, this.state.upl_descricao, this.state.arquivoBytes, this.state.indice);
        this.limpar();
    }

    render() {
        var docs = null;
        var listStyle = { listStyle: 'lower-latin', listStylePosition: 'inside' };
        if (this.props.origem === 'F') {

            docs = (
                <div>
                    <strong>  DOCUMENTOS NECESSÁRIOS DO FIADOR  </strong>
                    <ol type="a" style={listStyle}>
                        <li>Documentos de identificação: CPF, RG ou CNH;</li>
                        <li> Comprovante de residência: Conta de água, luz ou telefone;</li>
                        <li>Comprovante de renda: Holerite (dos últimos 3 meses) ou declaração do
                           IRPF; caso seja autônomo, extrato bancário dos últimos 3 meses;</li>
                        <li>Caso seja casado, apresentar os seguintes documentos do cônjuge: CPF,
                        RG ou CNH, Certidão de Casamento, e comprovante de renda conforme item c</li>
                    </ol>
                </div>
            );

        } else if (this.props.origem === 'G') {

            docs = (
                <div>
                    <p>
                        Entende-se como grupo familiar o conjunto de pessoas residindo na mesma
                        moradia do chefe do grupo familiar, que sejam relacionadas ao candidato pelos seguintes
                        graus de parentesco: Pai; Padrasto; Mãe; Madrasta; Cônjuge; Companheiro(a); Filho(a);
                        Enteado(a); Irmão(a); Avô(ó).
                        De cada membro do grupo familiar, o candidato deve apresentar e entregar
                            cópias dos seguintes documentos: <br />
                        <br />
                    </p>
                    <strong>  DOCUMENTOS NECESSÁRIOS DO INTERESSADO </strong>
                    <ol type="a" style={listStyle}>
                        <li>Documentos de identificação do interessado: CPF, RG ou CNH (frente e verso);</li>
                        <li>Comprovante de residência: Conta de água, luz ou telefone;</li>
                        <li> Comprovante de renda: Holerite ou Declaração de IRPF; caso seja autônomo, extrato bancário dos últimos três meses;</li>
                        <li>Caso seja casado, apresentar os seguintes documentos do cônjuge: CPF, RG ou CNH, Certidão de Casamento, e comprovante de renda conforme item c;</li>
                        <li> Comprovante da nota do Exame Nacional do Ensino Médio (ENEM) realizado a partir de 2010.</li>
                    </ol>
                    <br />
                    <strong>   DOCUMENTOS NECESSÁRIOS DO GRUPO FAMILIAR</strong>
                    <ol type="a" style={listStyle}>
                        <li> Documentos de identificação: CPF, RG ou CNH (frente e verso);</li>
                        <li> Quando menor, caso não tenha RG, apresentar a Certidão de Nascimento;</li>
                        <li>Comprovante de renda: Holerite ou Declaração do IRPF; caso seja autônomo, extrato bancário dos últimos três meses.</li>
                    </ol>
                </div>
            );
        }


        if (!this.state.exibeDoc) {
            docs = null;
        }

      
        let podeAlterar =   (this.state.itemSelected && (this.state.itemSelected.PodeAlterar || this.state.itemSelected.PodeAlterar === void(0)))  ||  (this.state.itemSelected && this.state.itemSelected.UplSeq <=0 );

     
        return (
            <fieldset>
                <legend>Envio de Documento(s) - {this.props.origem === 'G' ? 'Interessado/Grupo Familiar' : 'Fiador(es)'}</legend>
                <div style={{
                    textAlign: 'right',
                    padding: '0 0 20px 0'
                }}>
                    <a style={{ fontSize: '14px' }} href='#' onClick={(e) => { e.preventDefault(); this.toogleDoc(); }}>  {this.state.exibeDoc ? '[-]' : '[+]'} Ver documentos necessários</a>

                    <div style={{ display: docs ? 'block' : 'none', lineHeight: '20px', fontSize: '15px', textAlign: 'justify', padding: '20px', backgroundColor: 'rgb(238, 238, 238)' }}>
                        {docs}
                    </div>
                </div>

                <div id={this.state.id}>
                    <FormControl className='item-form'
                        style={{
                            width: '450px',
                            textAlign: "center"
                        }}>
                        <TextField

                            label="Descrição"
                            value={this.state.upl_descricao}
                            onChange={(e) => this.onChange('upl_descricao', e.target.value)}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className='item-form'
                        style={{
                            textAlign: "center"
                        }}>
                        <input
                            disabled={this.state.isVisualizacao}
                            onChange={(e) => { this.onChangeFile(e.target.files); }}
                            accept="image/*"
                            style={{ display: 'none' }}
                            id="raised-button-file"
                            type="file"
                        />
                        <label htmlFor="raised-button-file">
                            <Button

                                disabled={this.state.isVisualizacao}
                                variant="raised"
                                color="primary"
                                component="span"
                            >
                                <ImageIcon style={{ marginRight: "10px" }} />   Selecionar Imagem
                           </Button>
                        </label>
                        <FormHelperText >Obs: Selecione somente arquivos de imagem</FormHelperText>
                    </FormControl>

                    <div className='item-form'
                        style={{
                            display: 'inline-block'
                        }}>
                        {(this.state.isVisualizacao || this.state.isEdicao) ? (
                            <Button
                                style={{ marginRight: "10px" }}
                                onClick={() => { this.limpar(); }}
                                variant="raised" color="primary"   >
                                Cancelar
                            </Button>
                        ) : null}

                        {!this.state.isVisualizacao ? (
                            <Button
                                onClick={(e) => {
                                    this.save();
                                }}
                                variant="raised" color="primary" component="span"  >
                                {this.state.isEdicao ? "Alterar" : (<React.Fragment> <AddIcon style={{ marginRight: "10px" }} />Adicionar   </React.Fragment>)}
                            </Button>) : null}

                    </div>
                    <div>

                        {this.state.srcFile ? (
                            <div style={{
                                display: 'inline-block',
                                padding: '10px',
                                margin: '10px',
                                border: '1px solid #777'
                            }}>
                                <img
                                    src={this.state.srcFile}
                                    style={{
                                        maxHeight: '250px',
                                        maxWidth: '250px'
                                    }}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>




                <Paper style={{ marginTop: "80px" }} >

                    <Table style={{ width: "100%" }}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ width: '95%' }} component="th" scope="row" >Descrição&nbsp;</TableCell>
                                <TableCell numeric >{" "}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.listArquivos.map((item, indice) => {
                                return (
                                    <TableRow key={indice}>
                                        <TableCell style={{ width: "300px" }}>
                                            {item.UplDescricao}
                                        </TableCell>

                                        <TableCell  >
                                            <IconButton
                                                aria-label="More"
                                                aria-haspopup="true"
                                                onClick={this.handleClick.bind(this, item, indice)}

                                            >
                                                <MoreVertIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                    {this.props.listArquivos.length === 0 ? <div style={{ padding: '10px' }}>Nenhum Documento</div> : null}
                    <Menu
                        transitionDuration={0}
                        anchorEl={this.state.anchorEl}
                        open={Boolean(this.state.anchorEl)}
                        onClose={this.handleClose}
                    >

                        <MenuItem disabled={this.state.isEdicao } onClick={() => { this.onEditar(false); }} >
                            <ListItemIcon  >
                                <ZoomInIcon />
                            </ListItemIcon>
                            <ListItemText inset primary="Visualizar" />
                        </MenuItem>
                        <MenuItem disabled={this.state.isEdicao || !podeAlterar}  onClick={() => { this.onEditar(true); }} >
                            <ListItemIcon  >
                                <EditIcon />
                            </ListItemIcon>
                            <ListItemText inset primary="Editar" />
                        </MenuItem>
                        <MenuItem disabled={this.state.isEdicao || !podeAlterar} onClick={this.onDelete}>
                            <ListItemIcon  >
                                <DeleteIcon />
                            </ListItemIcon>
                            <ListItemText inset primary="Remover" />
                        </MenuItem>
                    </Menu>
                </Paper>
            </fieldset>
        );
    }
}




//=============
if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
            var dataURL = this.toDataURL(type, quality).split(',')[1];
            setTimeout(function () {

                var binStr = atob(dataURL),
                    len = binStr.length,
                    arr = new Uint8Array(len);

                for (var i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback(new Blob([arr], { type: type || 'image/png' }));

            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/components/file-upload.js